import { useSearchParams } from 'react-router-dom';
import { useEffect, useMemo } from 'react';

import { IFilterValues } from 'models';

export const useInitialSearchParams = ({ values, user }: { values: any; user?: any }) => {
	const [searchParams, setSearchParams] = useSearchParams();

	const initialValues = useMemo(() => {
		const modifiedParams = Array.from(searchParams);

		return modifiedParams.reduce((obj, item) => {
			if (obj.hasOwnProperty(item[0] as string | number | symbol)) {
				const i = item[0] as keyof IFilterValues;

				const newObj = obj[i] as string[];
				return {
					...obj,
					[item[0]]: [...newObj, item[1]],
				};
			} else {
				return item[0] === 'country' || item[0] === 'type'
					? { ...obj, [item[0]]: [item[1]] }
					: item[0] === 'excludeMyInvestment'
					? { ...obj, [item[0]]: item[1], investorId: user?.accountId }
					: { ...obj, [item[0]]: item[1] };
			}
		}, {} as IFilterValues);
	}, [searchParams]);

	useEffect(() => {
		if (values) {
			Object.keys(values).forEach((key) => {
				const isTo = key.includes('interestRate[to]');
				const from = +values['interestRate[from]'] || 0;
				const to = +values['interestRate[to]'] || 0;

				if (isTo && to < from) {
					delete values[key];
				}

				const isToAmount = key.includes('investedAmount[to]');
				const fromAmount = +values['investedAmount[from]'] || 0;
				const toAmount = +values['investedAmount[to]'] || 0;

				if (isToAmount && toAmount < fromAmount) {
					delete values[key];
				}

				if (!values[key]) {
					delete values[key];
				}
			});
		}

		setSearchParams(values);
	}, [values]);

	return { initialValues, setSearchParams };
};
